import HeadingsGenerator from '../../../src/components/content-ai-tools/HeadingsGenerator';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={HeadingsGenerator} />;
};

export default PublicDiscoveryKeywordsWrapped;
